
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireceb8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireceb8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $crzPX = parcelRequire("crzPX");
var $4790066c823bbd49$exports = {};
$4790066c823bbd49$exports = JSON.parse("{\"FTP_PATH\":\"/gwjp/\",\"PLATFORM\":\"jp\",\"LANGUAGE\":\"ja-JP\",\"EFE_ACTIVITY_HOST\":\"https://efe-activity.efunjp.com/\",\"PF_HOST\":\"https://pf.efunjp.com/\",\"PF_WEB_HOST\":\"https://m.efunjp.com/\",\"IMG_HOST\":\"https://imgi.efunjp.com/\",\"LOGIN_HOST\":\"https://login.efunjp.com/\",\"GAME_HOST\":\"https://game.efunjp.com/\",\"LOGIN_WEB_PATH\":\"https://m.efunjp.com/enter/login?from=\",\"CDN_HOST\":\"https://resjp-download.vsplay.com/res_jp\",\"PLATFORM_GAME_CODE\":\"efunjpplatform\",\"GAME_GPID\":1,\"GAME_DEPT\":48,\"FB_APP_ID\":\"821833207348226\",\"COOKIE_DOMAIN\":\"efunjp.com\",\"CODE_VERSION\":\"1.0\",\"gameCode\":\"jpklqb\",\"activityCode\":\"jpklqbPre\"}");


const $ecac38a8395632cd$export$6cd8cfbbf65bfbaf = [];
const $ecac38a8395632cd$export$86442f699be99a8d = [
    {
        selector: '.store .btn-ios',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u9996\u9875\u8DF3\u8F6CApp Store",
        label: "\u9996\u9875\u8DF3\u8F6CApp Store",
        parentDom: '.container1',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.store .btn-gp',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u9996\u9875\u8DF3\u8F6CGoogle Play",
        label: "\u9996\u9875\u8DF3\u8F6CGoogle Play",
        parentDom: '.container1',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.float-bottom-store[data-hash=2] .btn-store-ios',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u9884\u7EA6\u5956\u52B1\u677F\u5757\u8DF3\u8F6CApp Store",
        label: "\u9884\u7EA6\u5956\u52B1\u677F\u5757\u8DF3\u8F6CApp Store",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.float-bottom-store[data-hash=2] .btn-store-gp',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u9884\u7EA6\u5956\u52B1\u677F\u5757\u8DF3\u8F6CGoogle Play",
        label: "\u9884\u7EA6\u5956\u52B1\u677F\u5757\u8DF3\u8F6CGoogle Play",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.float-bottom-store[data-hash=3] .btn-store-ios',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u4E16\u754C\u89C0\u677F\u5757\u8DF3\u8F6CApp Store",
        label: "\u4E16\u754C\u89C0\u677F\u5757\u8DF3\u8F6CApp Store",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.float-bottom-store[data-hash=3] .btn-store-gp',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u4E16\u754C\u89C0\u677F\u5757\u8DF3\u8F6CGoogle Play",
        label: "\u4E16\u754C\u89C0\u677F\u5757\u8DF3\u8F6CGoogle Play",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.float-bottom-store[data-hash=4] .btn-store-ios',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u89D2\u8272\u4ECB\u7D39\u677F\u5757\u8DF3\u8F6CApp Store",
        label: "\u89D2\u8272\u4ECB\u7D39\u677F\u5757\u8DF3\u8F6CApp Store",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.float-bottom-store[data-hash=4] .btn-store-gp',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u89D2\u8272\u4ECB\u7D39\u677F\u5757\u8DF3\u8F6CGoogle Play",
        label: "\u89D2\u8272\u4ECB\u7D39\u677F\u5757\u8DF3\u8F6CGoogle Play",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.float-bottom-store[data-hash=5] .btn-store-ios',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u5546\u5E97\u5716\u677F\u5757\u8DF3\u8F6CApp Store",
        label: "\u5546\u5E97\u5716\u677F\u5757\u8DF3\u8F6CApp Store",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.float-bottom-store[data-hash=5] .btn-store-gp',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u5546\u5E97\u5716\u677F\u5757\u8DF3\u8F6CGoogle Play",
        label: "\u5546\u5E97\u5716\u677F\u5757\u8DF3\u8F6CGoogle Play",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.footer .bottom-store .ios',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u5E95\u90E8\u6309\u9215\u8DF3\u8F6CApp Store",
        label: "\u5E95\u90E8\u6309\u9215\u8DF3\u8F6CApp Store",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    },
    {
        selector: '.footer .bottom-store .gp',
        type: "\u70B9\u51FB\u9884\u7EA6",
        action: "\u5E95\u90E8\u6309\u9215\u8DF3\u8F6CGoogle Play",
        label: "\u5E95\u90E8\u6309\u9215\u8DF3\u8F6CGoogle Play",
        parentDom: 'body',
        once: true,
        storageKey: 'click_pre_btn',
        isPopup: false
    }
];
const $ecac38a8395632cd$export$6765b5a94465d2ef = [
    ...$ecac38a8395632cd$export$86442f699be99a8d
];
const $ecac38a8395632cd$export$d08c3e2d57bcc098 = [
    ...$ecac38a8395632cd$export$86442f699be99a8d
];
const $ecac38a8395632cd$export$6c08efadf280ad2f = [
    ...$ecac38a8395632cd$export$6cd8cfbbf65bfbaf
];
const $ecac38a8395632cd$export$57db5728151e63c7 = [
    ...$ecac38a8395632cd$export$6cd8cfbbf65bfbaf
];


const $c043dc842947a4bc$export$9666bbce1fb6a096 = {
    "ios": "https://apps.apple.com/jp/app/id6757525431",
    "gp": "https://play.google.com/store/apps/details?id=com.efun.jpklqb",
    "fbClub": "https://www.facebook.com/groups/2343340346120341",
    "fbFans": "https://www.facebook.com/yulgangw.mover/",
    "twitter": "",
    "discord": ""
};
const $c043dc842947a4bc$export$aa92494dfa16499a = '';
const $c043dc842947a4bc$export$495b8a9a16d3b28e = {
    "Smart&&Click&&ios-tt": {
        "index": "5,7,8",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=eba0af1a-ab91-4775-abd3-d5e639e7284e"
    },
    "Smart&&Subscribe&&ios-pangle": {
        "index": "5,7,8",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=dfc1742d-926d-4ce2-9bf2-6f87e5e3fe9c"
    },
    "dgv&&dis": {
        "index": "5,6",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=2982c7f6-cbb7-42ad-8210-85be7ee5607f"
    },
    "dgv&&short": {
        "index": "5,6",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=eaf3d1ae-de82-47a1-b700-db795f523436"
    },
    "dg": {
        "index": "5",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=0fd5178d-c42d-477c-8f63-bd9b0d617726"
    },
    "dgv": {
        "index": "5",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=9a6f1e96-e335-44cb-b63f-e50b1c900e84"
    },
    "pmax": {
        "index": "5",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=3c228807-8a19-4e06-a537-1c3d0f7f964f"
    },
    "fbresult&&SUBSCRIBE": {
        "index": "1,7",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=82d615d3-5726-414f-b236-f367cd0aed47"
    },
    "fbtraffic": {
        "index": "1",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=4fe28d86-14a3-43eb-9bd2-a36d9fff39d6"
    },
    "twitter": {
        "index": "1",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=edbd18e7-fd6c-431f-847a-25c26ffc9887"
    },
    "seedapp-zucks": {
        "index": "1",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=0a2e5c1f-c608-42b1-a709-e54b04603270"
    },
    "zucksadnw-zucks": {
        "index": "1",
        "link": "https://apps.apple.com/us/app/\u53EA\u4ECA-\u9AA8\u4F11\u3081\u4E2D/id6757525431?ppid=fad886b8-05a4-4305-b2b7-cebfc2f2c027"
    }
};
const $c043dc842947a4bc$export$523465427e649cc5 = {};
const $c043dc842947a4bc$export$fad8e825106d56c4 = {
    "Smart&&Click&&and-tt": {
        "index": "5,7,8",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=and-tt-click"
    },
    "Smart&&Subscribe&&and-pangle": {
        "index": "5,7,8",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=and-pangle-click"
    },
    "dgv&&dis": {
        "index": "5,6",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=gg-dgv-dis-click"
    },
    "dgv&&short": {
        "index": "5,6",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=gg-dgv-short-click"
    },
    "dg": {
        "index": "5",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=gg-dg-click"
    },
    "dgv": {
        "index": "5",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=gg-dgv-click"
    },
    "pmax": {
        "index": "5",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=gg-pmax-click"
    },
    "fbresult&&SUBSCRIBE": {
        "index": "1,7",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=fb-click"
    },
    "fbtraffic": {
        "index": "1",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=fb-kol-click"
    },
    "twitter": {
        "index": "1",
        "link": "https://play.google.com/store/apps/details?id=com.efun.jpklqb&listing=twitter-click"
    }
};
const $c043dc842947a4bc$export$469595e4a4231f4f = {};


// 手机号预约地区、手机号、预约按钮
const $dde4db35e1150dc5$export$7f1903c8dd208d22 = '.input-in, .pop-input-in';
const $dde4db35e1150dc5$export$fbae351d005d0527 = '.area, .pop-area';
const $dde4db35e1150dc5$export$16b758b4a4d28559 = '.btn-reservation';
const $dde4db35e1150dc5$export$1a2565247aed5ab1 = '.pop-btn-reservation';
const $dde4db35e1150dc5$export$a28bf5ffc69b2031 = `${$dde4db35e1150dc5$export$16b758b4a4d28559}, ${$dde4db35e1150dc5$export$1a2565247aed5ab1}`;
const $dde4db35e1150dc5$export$d7a271daff170df0 = [
    '.btn-gp',
    '.btn-pre[data-type=gp]',
    '.btn-reward[data-type=gp]',
    '.btn-float-reservation[data-type=gp]',
    '.pop-btn-gp',
    '.btn-nav-gp',
    '.btn-store-gp',
    '.store-pop-btn-gp',
    '.btn-bottom-gp',
    '.btn-reserve[data-type=gp]',
    '.btn-store-gp',
    '.short-btn-link-gp',
    '.pop-store-btn-gp',
    '.btn-gift-reservation[data-type=gp]',
    '.btn-bottom-reservation[data-type=gp]',
    '.btn-link-gp',
    '.pop-btn-ios-gp[data-type=gp]',
    '.btn-ios-gp[data-type=gp]',
    '.btn-reserve[data-type=gp]',
    '.btn-bottom-store[data-type=gp]',
    '.gp'
].join(',');
const $dde4db35e1150dc5$export$8f4920b5ce0c57f6 = [
    '.btn-ios',
    '.btn-pre[data-type=ios]',
    '.btn-reward[data-type=ios]',
    '.btn-float-reservation[data-type=ios]',
    '.pop-btn-ios',
    '.btn-nav-ios',
    '.btn-store-ios',
    '.store-pop-btn-ios',
    '.btn-bottom-ios',
    '.btn-reserve[data-type=ios]',
    '.btn-store-ios',
    '.short-btn-link-ios',
    '.pop-store-btn-ios',
    '.btn-gift-reservation[data-type=ios]',
    '.btn-bottom-reservation[data-type=ios]',
    '.btn-link-ios',
    '.pop-btn-ios-gp[data-type=ios]',
    '.btn-ios-gp[data-type=ios]',
    '.btn-reserve[data-type=ios]',
    '.btn-bottom-store[data-type=ios]',
    '.ios'
].join(',');
const $dde4db35e1150dc5$export$f70a646a4ba407d2 = [
    '.btn-facebook',
    '.btn-nav-fb',
    '.btn-fb',
    '.facebook',
    '.btn-nav-like'
].join(',');
const $dde4db35e1150dc5$export$2294bc6a63369b94 = [
    '.btn-twitter',
    '.twitter'
].join(',');
const $dde4db35e1150dc5$export$ba39a313d0b62f87 = [
    '.btn-discord',
    '.discord'
].join(',');
const $dde4db35e1150dc5$export$bd4d050bbc953f4e = [
    '.btn-talk',
    '.item-link2',
    '.btn-nav-talk',
    '.btn-community-talk'
].join(',');
const $dde4db35e1150dc5$export$cb74d3ddaf96c94b = [
    '.btn-cafe',
    '.item-link3',
    '.btn-nav-cafe',
    '.btn-community-cafe'
].join(',');
const $dde4db35e1150dc5$export$650e8bf94335f2a1 = '.pop-message-success';
const $dde4db35e1150dc5$export$6607e7346e9e0f7f = '.pop-pre';
const $dde4db35e1150dc5$export$14d6d57682a278ae = '.pop-pre-shake';
const $dde4db35e1150dc5$export$fd025f4375f32f1 = '.pop-pre-success';
const $dde4db35e1150dc5$export$b26f4ac691fc7c93 = '.pop-pre-had';
const $dde4db35e1150dc5$export$b3827dc10daf7ca4 = '.pop-rule';
const $dde4db35e1150dc5$export$4e02d88ab5434280 = '.pop-agreement';
const $dde4db35e1150dc5$export$939cf5b3080286bf = '.pop-through-pre';
const $dde4db35e1150dc5$export$3b1eb7044c3ec959 = '.pop-pre-success';
const $dde4db35e1150dc5$export$36a37ca1a88d728a = '.container3';
const $dde4db35e1150dc5$export$2f0d62b52adc8445 = '.btn-rule';
const $dde4db35e1150dc5$export$c0cf84007ded91ba = '.btn-rule-prize';
const $dde4db35e1150dc5$export$b51703b37319c438 = '.agreement';
const $dde4db35e1150dc5$export$fb13b879e31a159e = '.btn-rule-community';
const $dde4db35e1150dc5$export$ba36743765e1264a = '.pop-pangle';
const $dde4db35e1150dc5$export$a031478a8a29febd = [
    '.pop-pangle-btn'
].join(',');
const $dde4db35e1150dc5$export$2cebba4a2e83e853 = [
    '.pop-pangle-btn[data-type=gp]'
].join(',');
const $dde4db35e1150dc5$export$a279c224b52c492 = [
    '.pop-pangle-btn[data-type=ios]'
].join(',');
const $dde4db35e1150dc5$export$d91119fa26993f11 = [].join(',');


const $f87a224bf90dcb83$var$popupInstances = new Map();
const $f87a224bf90dcb83$var$popupOpenedSet = new Set();
function $f87a224bf90dcb83$export$c459441f6984099e() {
    const set = (selector, instance)=>{
        $f87a224bf90dcb83$var$popupOpenedSet.add(selector);
        $f87a224bf90dcb83$var$popupInstances.set(selector, instance);
    };
    const has = (selector)=>{
        return $f87a224bf90dcb83$var$popupInstances.has(selector);
    };
    const isOpened = (selector)=>{
        return !!$(selector).is(':visible');
    };
    const haveOpened = (selector)=>{
        return $f87a224bf90dcb83$var$popupOpenedSet.has(selector);
    };
    const openPopup = (selector, options)=>{
        const instance = $(selector).bPopup(options);
        $f87a224bf90dcb83$var$popupInstances.set(selector, instance);
        $f87a224bf90dcb83$var$popupOpenedSet.add(selector);
        return instance;
    };
    const closePopup = (selector)=>{
        var _a;
        const instance = $f87a224bf90dcb83$var$popupInstances.get(selector);
        (_a = instance === null || instance === void 0 ? void 0 : instance.close) === null || _a === void 0 || _a.call(instance);
        $f87a224bf90dcb83$var$popupInstances.delete(selector);
    };
    const closePopupAll = ()=>{
        $f87a224bf90dcb83$var$popupInstances.forEach((instance)=>{
            var _a;
            try {
                (_a = instance === null || instance === void 0 ? void 0 : instance.close) === null || _a === void 0 || _a.call(instance);
            } catch (_b) {
            // 已关闭的弹窗再次调用 close 会报错: Cannot read properties of null (reading 'onClose')
            // 为了避免通过非 closePopup / closePopupAll 关闭的弹窗再次调用 close 会报错所以使用 try-catch 处理此错误
            }
        });
        $f87a224bf90dcb83$var$popupInstances.clear();
    };
    return {
        set: set,
        has: has,
        isOpened: isOpened,
        haveOpened: haveOpened,
        openPopup: openPopup,
        closePopup: closePopup,
        closePopupAll: closePopupAll
    };
}



var $crzPX = parcelRequire("crzPX");

/** 排重标识 */ const $91e3366086257470$export$86880b4b2e1a2384 = {
    GTM_GP: 'track_gtm_all_shop_btn_gp',
    GTM_IOS: 'track_gtm_all_shop_btn_ios',
    GTM_PRE: 'track_gtm_success_pop',
    FB_SHOP: 'track_fb_all_shop_btn',
    FB_PRE: 'track_fb_pre_success',
    TT_PRE: 'track_tt_pre_success',
    TT_SHOP: 'track_tt_all_shop_btn',
    TT_PANGLE: 'track_tt_pangle_btn',
    X_GP: 'track_x_all_shop_btn_gp',
    X_IOS: 'track_x_all_shop_btn_ios',
    ZAF_IOS: 'track_zaf_all_shop_btn_ios',
    SEEDAPP_IOS: 'track_seedapp_all_shop_btn_ios'
};




var $crzPX = parcelRequire("crzPX");
const $231c0f66acb97373$export$9eeae922afdd48d = [
    {
        code: '886',
        placeholder: "\u4F8B\uFF1A0930000000",
        format: (phone)=>phone.slice(0, 1) !== '0' ? `0${phone}` : phone
    },
    {
        code: '852',
        placeholder: "\u4F8B\uFF1A91011111",
        format: (phone)=>phone.slice(0, 1) === '0' ? phone.slice(1) : phone
    },
    {
        code: '853',
        placeholder: "\u4F8B\uFF1A68111111",
        format: (phone)=>phone
    },
    {
        code: '60',
        placeholder: "\u4F8B\uFF1A121111111",
        format: (phone)=>phone.slice(0, 1) === '0' ? phone.slice(1) : phone
    },
    {
        code: '65',
        placeholder: "\u4F8B\uFF1A90111111",
        format: (phone)=>phone.slice(0, 1) === '0' ? phone.slice(1) : phone
    }
];


var $159cc7e486f2a764$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $159cc7e486f2a764$export$260e882f431d977c() {
    let activityConfig = null;
    let areaConfigList = [];
    const getActivityConfig = ()=>$159cc7e486f2a764$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const { data: data } = yield (0, $crzPX.getActivityInfoByApi)('payType');
            try {
                data.activityMsgConfig.activityMsg.context = JSON.parse((_a = data.activityMsgConfig.activityMsg.context) !== null && _a !== void 0 ? _a : '{}');
                data.activityMsgConfig.activityMsg.payType = JSON.parse((_b = data.activityMsgConfig.activityMsg.payType) !== null && _b !== void 0 ? _b : '{}');
            } catch (error) {
            //
            }
            activityConfig = data;
            return activityConfig !== null && activityConfig !== void 0 ? activityConfig : {};
        });
    const getAreaConfig = ()=>$159cc7e486f2a764$var$__awaiter(this, void 0, void 0, function*() {
            if (!areaConfigList.length) {
                const { code: code, data: data } = yield (0, $crzPX.getAreaConfigListByApi)();
                if (code === 'e1000' && data) areaConfigList = data.filter((val)=>(0, $231c0f66acb97373$export$9eeae922afdd48d).find(({ code: code })=>code === val.areaCode));
            }
            return areaConfigList;
        });
    return {
        getActivityConfig: getActivityConfig,
        getAreaConfig: getAreaConfig
    };
}



function $164e48e1c52b42e0$export$30a06c8d3562193f(object, keys) {
    const ownKeys = [
        ...Object.keys(object),
        ...Object.getOwnPropertySymbols(object)
    ];
    return ownKeys.reduce((result, key)=>{
        if (!keys.includes(key)) result[key] = object[key];
        return result;
    }, {});
}


var $7644592b74195952$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7644592b74195952$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const { getActivityConfig: $7644592b74195952$var$getActivityConfig } = (0, $159cc7e486f2a764$export$260e882f431d977c)();
const { openPopup: $7644592b74195952$var$openPopup, closePopupAll: $7644592b74195952$var$closePopupAll } = (0, $f87a224bf90dcb83$export$c459441f6984099e)();
let $7644592b74195952$var$_openIosPangle = false;
let $7644592b74195952$var$_openAndPangle = false;
function $7644592b74195952$var$gpStoreTrack() {
    (0, $crzPX.trackGTM)({
        once: true,
        storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).GTM_GP,
        data: {
            send_to: 'AW-18128941059/pj6pCM6tqqgcEIPgxsRD',
            value: 1.0,
            currency: 'USD'
        }
    });
}
function $7644592b74195952$var$iosStoreTrack() {
    (0, $crzPX.trackGTM)({
        once: true,
        storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).GTM_IOS,
        data: {
            send_to: 'AW-18128941059/fNdeCK2tqqgcEIPgxsRD',
            value: 2.0,
            currency: 'USD'
        }
    });
    $7644592b74195952$var$zafIosStoreTrack();
    $7644592b74195952$var$seedappIosStoreTrack();
}
function $7644592b74195952$var$zafIosStoreTrack() {
    if ((0, $crzPX.getLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).ZAF_IOS)) return;
    $('body').append('<script id="zafscript" src="https://get.mobu.jp.eimg.jp/js/conv/conv.min.js?actcd=d292eb40bf1468a744dbe005e0a47ab2"></script>');
    (0, $crzPX.setLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).ZAF_IOS, '1');
}
function $7644592b74195952$var$seedappIosStoreTrack() {
    if ((0, $crzPX.getLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).SEEDAPP_IOS)) return;
    $('body').append('<span id="a8sales"></span><script src="//statics.a8.net/a8sales/a8sales.js"></script><script>a8sales({pid:"s00000020278142",order_number:"1",currency:"JPY",items:[{code:"1",price:1,quantity:1}],total_price:1});</script>');
    (0, $crzPX.setLocalStorage)((0, $91e3366086257470$export$86880b4b2e1a2384).SEEDAPP_IOS, '1');
}
function $7644592b74195952$var$allStoreTrack(ttEvent = 'ClickButton') {
    (0, $crzPX.trackFB)({
        once: true,
        storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).FB_SHOP,
        event: 'Subscribe',
        data: {
            currency: 'USD',
            value: 0.0
        }
    });
    (0, $crzPX.trackTT)({
        once: true,
        storageKey: (0, $91e3366086257470$export$86880b4b2e1a2384).TT_SHOP,
        event: ttEvent
    });
}
function $7644592b74195952$var$openPanglePopup() {
    $7644592b74195952$var$closePopupAll();
    $7644592b74195952$var$openPopup((0, $dde4db35e1150dc5$export$ba36743765e1264a));
}
function $7644592b74195952$export$3c6b9e396446483e() {
    var _a, _b, _c;
    return $7644592b74195952$var$__awaiter(this, void 0, void 0, function*() {
        try {
            const activityConfig = yield $7644592b74195952$var$getActivityConfig();
            const { openIosPangle: openIosPangle = false, openAndPangle: openAndPangle = false } = (_c = (_b = (_a = activityConfig === null || activityConfig === void 0 ? void 0 : activityConfig.activityMsgConfig) === null || _a === void 0 ? void 0 : _a.activityMsg) === null || _b === void 0 ? void 0 : _b.context) !== null && _c !== void 0 ? _c : {};
            $7644592b74195952$var$_openIosPangle = openIosPangle;
            $7644592b74195952$var$_openAndPangle = openAndPangle;
        } finally{
            const isAndPangle = $7644592b74195952$var$_openAndPangle && $7644592b74195952$export$ac429f11ac014fb5();
            const isIosPangle = $7644592b74195952$var$_openIosPangle && $7644592b74195952$export$f1a0c7bc35d9df48();
            if (isAndPangle) $((0, $dde4db35e1150dc5$export$2cebba4a2e83e853)).on('click', ()=>{
                $7644592b74195952$var$closePopupAll();
            });
            if (isIosPangle) $((0, $dde4db35e1150dc5$export$a279c224b52c492)).on('click', ()=>{
                $7644592b74195952$var$closePopupAll();
            });
            $7644592b74195952$var$listenStoreTrack(isAndPangle, isIosPangle);
        }
    });
}
function $7644592b74195952$var$listenStoreTrack(isAndPangle, isIosPangle) {
    const storeConfig = (0, $crzPX.isMb)() ? (0, $ecac38a8395632cd$export$6765b5a94465d2ef) : (0, $ecac38a8395632cd$export$d08c3e2d57bcc098);
    if (!isAndPangle && !isIosPangle) storeConfig.forEach((_a)=>{
        var { selector: selector, parentDom: parentDom } = _a, options = $7644592b74195952$var$__rest(_a, [
            "selector",
            "parentDom"
        ]);
        if (parentDom) $(parentDom).on('click', selector, ()=>(0, $crzPX.trackGA)(options));
        else $(selector).on('click', ()=>(0, $crzPX.trackGA)(options));
    });
    $(document).on('click', (0, $dde4db35e1150dc5$export$d7a271daff170df0), (e)=>{
        var _a;
        const $target = $(e.target);
        const ignored = $target.closest((0, $dde4db35e1150dc5$export$d91119fa26993f11)).length > 0;
        if (!ignored && isAndPangle) {
            const triggedGaConfig = (_a = storeConfig.find(({ selector: selector })=>$target.closest(selector).length > 0)) !== null && _a !== void 0 ? _a : null;
            $((0, $dde4db35e1150dc5$export$a031478a8a29febd)).data('gaConfig', triggedGaConfig);
            e.preventDefault();
            $7644592b74195952$var$openPanglePopup();
        } else {
            $7644592b74195952$var$gpStoreTrack();
            $7644592b74195952$var$allStoreTrack();
        }
    });
    $(document).on('click', (0, $dde4db35e1150dc5$export$8f4920b5ce0c57f6), (e)=>{
        var _a;
        const $target = $(e.target);
        const ignored = $target.closest((0, $dde4db35e1150dc5$export$d91119fa26993f11)).length > 0;
        if (!ignored && isIosPangle) {
            const triggedGaConfig = (_a = storeConfig.find(({ selector: selector })=>$target.closest(selector).length > 0)) !== null && _a !== void 0 ? _a : null;
            $((0, $dde4db35e1150dc5$export$a031478a8a29febd)).data('gaConfig', triggedGaConfig);
            e.preventDefault();
            $7644592b74195952$var$openPanglePopup();
        } else {
            $7644592b74195952$var$iosStoreTrack();
            $7644592b74195952$var$allStoreTrack();
        }
    });
    $((0, $dde4db35e1150dc5$export$a031478a8a29febd)).on('click', (e)=>{
        const { type: type = 'gp', gaConfig: gaConfig = null } = $((0, $dde4db35e1150dc5$export$a031478a8a29febd)).data();
        const storeTrackGTM = type === 'gp' ? $7644592b74195952$var$gpStoreTrack : $7644592b74195952$var$iosStoreTrack;
        storeTrackGTM();
        $7644592b74195952$var$allStoreTrack('Subscribe');
        if (gaConfig) (0, $crzPX.trackGA)((0, $164e48e1c52b42e0$export$30a06c8d3562193f)(gaConfig, [
            'parentDom',
            'selector'
        ]));
    });
}
function $7644592b74195952$export$eb384ffe03b07dcd() {
    return $7644592b74195952$var$_openIosPangle && $7644592b74195952$export$f1a0c7bc35d9df48();
}
function $7644592b74195952$export$b26f9241999587ca() {
    return $7644592b74195952$var$_openAndPangle && $7644592b74195952$export$ac429f11ac014fb5();
}
function $7644592b74195952$export$f1a0c7bc35d9df48() {
    const params = (0, $crzPX.getCampaignName)();
    return [
        "^(?:[^_]*_){7}(ios-pangle|all-all|ios-all)(?:_|$).*"
    ].some((r)=>new RegExp(r).test(params));
}
function $7644592b74195952$export$ac429f11ac014fb5() {
    const params = (0, $crzPX.getCampaignName)();
    return [
        "^(?:[^_]*_){7}(and-pangle|all-all|and-all)(?:_|$).*"
    ].some((r)=>new RegExp(r).test(params));
}



var $crzPX = parcelRequire("crzPX");
const $dafc309824924c86$export$4353f9746f37a879 = [];
const $dafc309824924c86$export$1907a3495be06cb9 = [];
const $dafc309824924c86$export$7d7346082674a46c = [];




const { gameCode: $5171eff5770e9c66$var$gameCode, activityCode: $5171eff5770e9c66$var$activityCode, PLATFORM: $5171eff5770e9c66$var$PLATFORM, LANGUAGE: $5171eff5770e9c66$var$LANGUAGE } = (0, (/*@__PURE__*/$parcel$interopDefault($4790066c823bbd49$exports)));
const $5171eff5770e9c66$var$shuntTuple = [
    [
        ()=>(0, $cd9b99aa0bd6bc06$export$392765b61b204f51),
        'abt-shame'
    ],
    [
        ()=>(0, $cd9b99aa0bd6bc06$export$3f8b846eb84e1d32),
        'store-version'
    ]
];
function $5171eff5770e9c66$export$bda9c629ea222300() {
    return $5171eff5770e9c66$var$shuntTuple.reduce((classes, [condition, cls])=>condition() ? `${classes} ${cls}` : classes, '');
}
function $5171eff5770e9c66$export$bedf86420e99d00() {
    return {
        gameCode: $5171eff5770e9c66$var$gameCode,
        activityCode: $5171eff5770e9c66$var$activityCode,
        platform: $5171eff5770e9c66$var$PLATFORM,
        language: $5171eff5770e9c66$export$276b7e40b5c8f9e9()
    };
}
function $5171eff5770e9c66$export$276b7e40b5c8f9e9() {
    return document.documentElement.lang || $5171eff5770e9c66$var$LANGUAGE;
}
const $5171eff5770e9c66$export$7d15b64cf5a3a4c4 = (num, min, max)=>Math.min(max, Math.max(min, num));
function $5171eff5770e9c66$export$c3cc20222ed8a198() {
    const pathname = location.pathname;
    const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);
    return fileName.replace(/\.html$/, '');
}


const $cd9b99aa0bd6bc06$var$campaignName = (0, $crzPX.getCampaignName)();
const $cd9b99aa0bd6bc06$var$utmMedium = (0, $crzPX.getQueryString)('utm_medium');
const $cd9b99aa0bd6bc06$export$3f8b846eb84e1d32 = (0, $5171eff5770e9c66$export$c3cc20222ed8a198)() === 'store';
const $cd9b99aa0bd6bc06$export$3bd08d75a2de21fd = (0, $5171eff5770e9c66$export$c3cc20222ed8a198)() === 'short';
console.log($cd9b99aa0bd6bc06$export$3f8b846eb84e1d32);
const $cd9b99aa0bd6bc06$export$306273ffea313c18 = (0, $dafc309824924c86$export$1907a3495be06cb9).some((reg)=>new RegExp(reg).test($cd9b99aa0bd6bc06$var$utmMedium));
const $cd9b99aa0bd6bc06$export$392765b61b204f51 = (0, $dafc309824924c86$export$7d7346082674a46c).some((reg)=>new RegExp(reg).test($cd9b99aa0bd6bc06$var$campaignName));
const $cd9b99aa0bd6bc06$export$721b3ad33d61b9a8 = ()=>{
    return (0, $5171eff5770e9c66$export$276b7e40b5c8f9e9)() === 'en';
};
const $cd9b99aa0bd6bc06$export$654fc7d9d5cff710 = ()=>{
    return (0, $5171eff5770e9c66$export$276b7e40b5c8f9e9)() === 'de';
};
const $cd9b99aa0bd6bc06$export$342aebe5375b7924 = ()=>{
    return (0, $5171eff5770e9c66$export$276b7e40b5c8f9e9)() === 'fr';
};
const $cd9b99aa0bd6bc06$export$7a7cc8de63adf369 = ()=>{
    return (0, $5171eff5770e9c66$export$276b7e40b5c8f9e9)() === 'tr';
};



var $4e0ab7089fc43413$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-ignore
// import PcKV from '../images/KV4/pc.mp4'
// import MbKV from '../MB.mp4'
const { openPopup: $4e0ab7089fc43413$var$openPopup, closePopupAll: $4e0ab7089fc43413$var$closePopupAll } = (0, $f87a224bf90dcb83$export$c459441f6984099e)();
function $4e0ab7089fc43413$export$cbd0a4babc275a37() {
    // 初始化 ABT 视频
    $4e0ab7089fc43413$var$initVideo();
    // 初始化页面版本：电话版 or 商店版 or 遮羞版
    $4e0ab7089fc43413$var$initPageVersion();
    // 初始化页面多语言切换
    // initPageAnchor()
    // 初始化 @efe-activity-fe-util 工具
    $4e0ab7089fc43413$var$initUtilConfig();
    // 初始化页面上所有商店按钮链接
    $4e0ab7089fc43413$var$initStoreBtnLink();
    // 初始化商店按钮埋点
    $4e0ab7089fc43413$var$initStoreTrack();
    // 初始化预约人数
    $4e0ab7089fc43413$var$initPreNumber();
// 初始化角色轮播图：有操作时暂停播放
// initRoleSwiper()
}
function $4e0ab7089fc43413$var$initRoleSwiper() {
    function pauseAutoplayWithDelay() {
        var _a;
        (_a = window.roleSwiper) === null || _a === void 0 || _a.autoplay.stop();
    }
    const el = document.querySelector('.container2');
    if (el) (0, $crzPX.useIntersectionObserver)(el, ([entry])=>{
        var _a;
        if (entry.isIntersecting) (_a = window.roleSwiper) === null || _a === void 0 || _a.autoplay.start();
        else {
            setTimeout(()=>{
                var _a;
                (_a = window.roleSwiper) === null || _a === void 0 || _a.slideTo((0, $crzPX.isPc)() ? 0 : 0);
            }, 100);
            pauseAutoplayWithDelay();
        }
    }, {
        threshold: 0.5
    });
    $('.role-container').on('mousedown touchstart click', '.swiper-slide, .shapeshifting, .btn-video, .swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet', pauseAutoplayWithDelay);
}
function $4e0ab7089fc43413$var$initVideo() {
    // window.kvUrl = isPc()
    //     ? 'https://resgl-download.efunsea.com/res_gl/eud3/eud3Pre/KV1/PC.mp4'
    //     : MbKV
    // window.kvUrl = isPc() ? PcKV : MbKV
    if (typeof window.lozad !== 'function' || !window.kvUrl) return;
    $('.kv-video').show().addClass('loaded').append(// @ts-ignore
    `<video class="kv-video-box lozad" autoplay muted loop playsinline><source src="${window.kvUrl}"></source></video>`);
    if ((0, $crzPX.isPc)()) $(window).on('hashchange', ()=>{
        var _a, _b;
        const { hash: hash } = window.location;
        if (hash === '#section-01') (_b = (_a = $(`.kv-video-box`)[0]) === null || _a === void 0 ? void 0 : _a.play) === null || _b === void 0 || _b.call(_a);
    });
}
function $4e0ab7089fc43413$var$initPageVersion() {
    $('#app').addClass((0, $5171eff5770e9c66$export$bda9c629ea222300)());
// $.extend(($.fn.bPopup as any).defaults, { appendTo: '#app' })
}
function $4e0ab7089fc43413$var$initPageAnchor() {
    const normalizePath = (path)=>{
        if (!path.startsWith('/')) path = '/' + path;
        if (path.endsWith('/')) path = path.slice(0, -1);
        return path;
    };
    $('.page-anchor').on('click', (e)=>{
        e.preventDefault();
        const { origin: origin, search: search, hash: hash, pathname: pathname } = window.location;
        const htmlFilename = normalizePath($(e.target).data('href') || 'index.html');
        const url = origin + pathname.replace(/\/([^\/]*)$/, htmlFilename) + search + hash;
        window.localStorage.setItem('lang_is_redirect', '1');
        window.location.href = url;
    });
}
function $4e0ab7089fc43413$var$initUtilConfig() {
    // const pageLang = getHtmlFileNameWithoutExt() || 'index'
    // const lang = {
    //     index: 'zh-CN',
    //     en: 'en-US',
    //     id: 'id-ID',
    //     th: 'th-TH',
    // }
    // Config.LANGUAGE = lang[pageLang] ?? Config.LANGUAGE
    new (0, $crzPX.EFE_ACTIVITY_FE_UTIL)((0, (/*@__PURE__*/$parcel$interopDefault($4790066c823bbd49$exports))), (0, $crzPX.isPc)() ? (0, $ecac38a8395632cd$export$57db5728151e63c7) : (0, $ecac38a8395632cd$export$6c08efadf280ad2f));
}
function $4e0ab7089fc43413$var$initStoreTrack() {
    (0, $7644592b74195952$export$3c6b9e396446483e)();
}
function $4e0ab7089fc43413$var$initPreNumber() {
    return $4e0ab7089fc43413$var$__awaiter(this, void 0, void 0, function*() {
        const { data: data } = yield (0, $crzPX.getPreNumInfoByApi)();
        const preNumber = Number(data === null || data === void 0 ? void 0 : data.totalPreNum);
        $4e0ab7089fc43413$var$renderMask(preNumber);
    });
}
function $4e0ab7089fc43413$var$initStoreBtnLink() {
    const { ios: ios, gp: gp, fbClub: fbClub, fbFans: fbFans, twitter: twitter, discord: discord } = (0, $c043dc842947a4bc$export$9666bbce1fb6a096);
    const iosLink = (0, $cd9b99aa0bd6bc06$export$306273ffea313c18) ? (0, $c043dc842947a4bc$export$aa92494dfa16499a) : (0, $crzPX.toggleCppIOSLink)((0, $cd9b99aa0bd6bc06$export$3f8b846eb84e1d32) || (0, $cd9b99aa0bd6bc06$export$3bd08d75a2de21fd) ? (0, $c043dc842947a4bc$export$523465427e649cc5) : (0, $c043dc842947a4bc$export$495b8a9a16d3b28e), ios);
    const ggLink = (0, $crzPX.toggleCppIOSLink)((0, $cd9b99aa0bd6bc06$export$3f8b846eb84e1d32) || (0, $cd9b99aa0bd6bc06$export$3bd08d75a2de21fd) ? (0, $c043dc842947a4bc$export$469595e4a4231f4f) : (0, $c043dc842947a4bc$export$fad8e825106d56c4), gp);
    $((0, $dde4db35e1150dc5$export$8f4920b5ce0c57f6)).attr({
        href: iosLink,
        target: '_blank'
    });
    $((0, $dde4db35e1150dc5$export$d7a271daff170df0)).attr({
        href: ggLink,
        target: '_blank'
    });
    $((0, $dde4db35e1150dc5$export$f70a646a4ba407d2)).attr({
        href: fbFans,
        target: '_blank'
    });
    $('.btn-facebook-club').attr({
        href: fbClub,
        target: '_blank'
    });
    $((0, $dde4db35e1150dc5$export$2294bc6a63369b94)).attr({
        href: twitter,
        target: '_blank'
    });
    $((0, $dde4db35e1150dc5$export$ba39a313d0b62f87)).attr({
        href: discord,
        target: '_blank'
    });
    $((0, $dde4db35e1150dc5$export$2cebba4a2e83e853)).attr({
        href: ggLink,
        target: '_blank'
    });
    $((0, $dde4db35e1150dc5$export$a279c224b52c492)).attr({
        href: iosLink,
        target: '_blank'
    });
}
function $4e0ab7089fc43413$var$renderMask(total) {
    $('.sub-num').html((0, $crzPX.formatNumberWithCommas)(total));
    if (total >= 50000) {
        $('.cleared1').show();
        $('.finsh-line').addClass('finsh1');
        $('.finsh-dot').addClass('step1');
    }
    if (total >= 100000) {
        $('.cleared2').show();
        $('.finsh-line').removeClass('finsh1').addClass('finsh2');
        $('.finsh-dot').removeClass('step1').addClass('step2');
    }
    if (total >= 200000) {
        $('.cleared3').show();
        $('.finsh-line').removeClass('finsh2').addClass('finsh3');
        $('.finsh-dot').removeClass('step2').addClass('step3');
    }
    if (total >= 300000) {
        $('.cleared4').show();
        $('.finsh-line').removeClass('finsh3').addClass('finsh4');
        $('.finsh-dot').removeClass('step3').addClass('step4');
    }
    if (total >= 777777) {
        $('.cleared5').show();
        $('.finsh-line').removeClass('finsh4').addClass('finsh5');
        $('.finsh-dot').removeClass('step4').addClass('step5');
        $('.progress-bar').addClass('finsh-on');
    }
}



var $crzPX = parcelRequire("crzPX");



var $f49e4188f78569fd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const { gameCode: $f49e4188f78569fd$var$gameCode, activityCode: $f49e4188f78569fd$var$activityCode } = (0, (/*@__PURE__*/$parcel$interopDefault($4790066c823bbd49$exports)));
const $f49e4188f78569fd$var$preStatusKey = `${$f49e4188f78569fd$var$gameCode}_${$f49e4188f78569fd$var$activityCode}_pre_status`;
const { openPopup: $f49e4188f78569fd$var$openPopup, closePopupAll: $f49e4188f78569fd$var$closePopupAll } = (0, $f87a224bf90dcb83$export$c459441f6984099e)();
function $f49e4188f78569fd$export$36aff1fbb4f5dfc6() {
    return $f49e4188f78569fd$var$__awaiter(this, void 0, void 0, function*() {
        $f49e4188f78569fd$var$bindEvent();
    });
}
function $f49e4188f78569fd$export$89737c494f8cc4e9() {
    return !!(0, $crzPX.getLocalStorage)($f49e4188f78569fd$var$preStatusKey);
}
function $f49e4188f78569fd$export$e79e32a7737255d5() {
    (0, $crzPX.setLocalStorage)($f49e4188f78569fd$var$preStatusKey, 1);
}
function $f49e4188f78569fd$var$bindEvent() {
// scrollOpenPopup(ROLE_POPUP_HOST_SELECTOR)
// $(`${ALL_GP_SELECTOR}, ${ALL_IOS_SELECTOR}`).on('click', () => {
//     closePopupAll()
//     if (!getPreStatus()) {
//         trackPopupGa(SHOP_PRE_SUCCESS_POPUP_SELECTOR)
//     }
//     setPreStatus()
//     // window.openPreSuccessPopup = true
//     // closePopupAll()
//     // trackPopupGa(PRE_SUCCESS_POPUP_SELECTOR, PRE_SUCCESS_POPUP_SELECTOR, {
//     //     onClose: () => {
//     //         window?.popupCloseHandler?.()
//     //         window.openPreSuccessPopup = false
//     //     },
//     // })
// })
}
function $f49e4188f78569fd$var$scrollOpenPopup(selector) {
    if ($f49e4188f78569fd$export$89737c494f8cc4e9()) return;
    const el = document.querySelector(selector);
    if (!el) return;
    let last = 0;
    const observer = new IntersectionObserver(([entry])=>{
        if ($f49e4188f78569fd$export$89737c494f8cc4e9() || last > 0) {
            observer.disconnect();
            return;
        }
        const now = Date.now();
        if (!entry.isIntersecting || now - last < 0) return;
        $f49e4188f78569fd$var$closePopupAll();
        $f49e4188f78569fd$var$openPopup((0, $dde4db35e1150dc5$export$939cf5b3080286bf));
        last = now;
    }, {
        threshold: 0.5
    });
    observer.observe(el);
}




$(()=>{
    (0, $4e0ab7089fc43413$export$cbd0a4babc275a37)();
    (0, $f49e4188f78569fd$export$36aff1fbb4f5dfc6)();
});


//# sourceMappingURL=jpklqbPre.9642c4e1.js.map
